import React from 'react'
import { OptimizelyExperiments } from 'constants/optimizely'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import TextButton from 'LuxKit/Button/TextButton'

export function ViewOfferButton(
  {
    variant,
    textOnly = false,
  }:
  {
    variant: 'default' | 'condensed'
    textOnly?: boolean
  },
) {
  const testVariant: 'control' | 'see_deal' | undefined = useOptimizelyExperiment(OptimizelyExperiments.croOfferCtaSeeDeal)
  if (textOnly) {
    if (testVariant === 'see_deal') {
      return <>See deal</>
    } else {
      return <>View offer</>
    }
  } else {
    if (variant === 'default') {
      return <CSSBreakpoint min="desktop">
        <TextButton kind="primary" nonInteractable>
          View
        </TextButton>
      </CSSBreakpoint>
    } else if (variant === 'condensed' && testVariant === 'see_deal') {
      return <TextButton kind="secondary" nonInteractable>
        See <CSSBreakpoint as="span" min="desktop">&nbsp;deal</CSSBreakpoint>
      </TextButton>
    } else {
      return <TextButton kind="secondary" nonInteractable>
        View <CSSBreakpoint as="span" min="desktop">&nbsp;offer</CSSBreakpoint>
      </TextButton>
    }
  }
}
